import script from "./step8RecruitmentFeedback.vue?vue&type=script&setup=true&lang=ts"
export * from "./step8RecruitmentFeedback.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__